import { render } from "./ColorPillBase.vue?vue&type=template&id=7b76f1b8"
import script from "./ColorPillBase.vue?vue&type=script&lang=js"
export * from "./ColorPillBase.vue?vue&type=script&lang=js"

import "./ColorPillBase.vue?vue&type=style&index=0&id=7b76f1b8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__